import React from "react";
import { Button, Select, SelectItem } from "@heroui/react";
import { IconColorFilter } from "@tabler/icons-react";

interface Color {
  key: string;
  bg: string;
  value: string;
}

export const colorsDataUA: Color[] = [
  { key: "red", bg: "bg-red-500", value: "Red" },
  { key: "blue", bg: "bg-blue-500", value: "Blue" },
  { key: "yellow", bg: "bg-yellow-500", value: "Yellow" },
  { key: "green", bg: "bg-green-500", value: "Green" },
  { key: "purple", bg: "bg-purple-500", value: "Purple" },
];

export const colorsDataRB: Color[] = [
  { key: "red", bg: "bg-red-500", value: "Red" },
  { key: "green", bg: "bg-green-500", value: "Green" },
  { key: "blue", bg: "bg-blue-500", value: "Blue" },
  { key: "orange", bg: "bg-orange-500", value: "Orange" },
  { key: "purple", bg: "bg-purple-500", value: "Purple" },
  { key: "yellow", bg: "bg-yellow-500", value: "Yellow" },
];

const colorsData: Color[] = [
  { key: "red", bg: "bg-red-500", value: "Red" },
  { key: "green", bg: "bg-green-500", value: "Green" },
  { key: "blue", bg: "bg-blue-500", value: "Blue" },
  { key: "purple", bg: "bg-purple-500", value: "Purple" },
  { key: "black", bg: "bg-slate-500", value: "Black" },
  { key: "yellow", bg: "bg-yellow-500", value: "Yellow" },
];

export function ColorFilterUA({
  selected,
  setSelected,
  className,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  className?: string;
}) {
  return (
    <ColorFilter
      selected={selected}
      setSelected={setSelected}
      className={className}
      colors={colorsDataUA}
      selectionMode="single"
    />
  );
}

export function ColorFilterRB({
  selected,
  setSelected,
  className,
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  className?: string;
}) {
  return (
    <ColorFilter
      selected={selected}
      setSelected={setSelected}
      className={className}
      colors={colorsDataRB}
      selectionMode="multiple"
    />
  );
}

export default function ColorFilter({
  selected,
  setSelected,
  className,
  colors = undefined,
  selectionMode = "multiple",
}: {
  selected: Set<any>;
  setSelected: (selectedOptions: Set<string>) => void;
  className?: string;
  colors?: Color[] | undefined;
  selectionMode?: "multiple" | "single";
}) {
  const handleSelectionChange = (selectedKeys: any) => {
    // Convert Selection to an array of strings
    const selectedItems = Array.from(selectedKeys).map((key) => key as string);
    const newSelection = new Set(selectedItems);
    setSelected(newSelection);
  };
  const handleReset = () => {
    setSelected(new Set());
  };

  const colorsToUse = colors || colorsData;

  return (
    <div className={"w-[120px] " + className}>
      <Select
        size="sm"
        aria-label={"Color"}
        placeholder="Color"
        selectedKeys={Array.from(selected)}
        selectionMode={selectionMode}
        startContent={<IconColorFilter />}
        className="max-w-xs"
        onSelectionChange={handleSelectionChange}
      >
        {colorsToUse.map((color) => (
          <SelectItem
            key={color.key}
            startContent={
              <div className={`${color.bg} rounded-full h-2 w-2`}></div>
            }
          >
            {color.value}
          </SelectItem>
        ))}
      </Select>
      {/* <Button color="primary" onClick={handleReset}>
                Reset
            </Button> */}
      {/* <p className="text-small text-default-500">Selected: {Array.from(selected).join(', ')}</p> */}
    </div>
  );
}
